import { FiExternalLink } from 'react-icons/fi';
import React from "react";

interface ExternalAnchorProps {
  link?: string;
  classes?: string;
  prevText: string;
  onClick?: () => void;
  tabIndex?: number;
}

const ExternalAnchor: React.FC<ExternalAnchorProps> = ({ link, classes, prevText, onClick, tabIndex }) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (onClick) {
      e.preventDefault(); // Prevent default link behavior when onClick is provided
      onClick();
    }
    // If no onClick, let the default link behavior proceed
  };

  return (
      <a
          className="text-ghColorPrimary-100"
          rel="noopener noreferrer"
          href={link}
          target={onClick ? undefined : (link ? "_blank" : undefined)}
          onClick={handleClick}
          tabIndex={tabIndex}
      >
        &nbsp;
        <span className={`text-ghColorPrimary-100 cursor-pointer ${classes}`}>
        {prevText}&nbsp;
      </span>
        <FiExternalLink className="inline hover:scale-110" />
        &nbsp;
      </a>
  );
};

export default ExternalAnchor;
